import { Box, HStack, Spinner, Stack } from "@chakra-ui/react";
import { Form, UI } from "components";
import useCities from "hooks/useCities";
import useCountries from "hooks/useConuntries";
import useStates from "hooks/useStates";
import { useEffect, useState } from "react";

export default function Location({ required, disabled, defaultCity, onChange = () => {}, ...props }){

    const countries = useCountries()
    const [ country, setCountry ] = useState(defaultCity?.country_id)
    const states = useStates(country)
    const [ state, setState ] = useState(defaultCity?.state_id)
    const cities = useCities(state)
    const [ city, setCity ] = useState(defaultCity?.id)

    const countries_fileted = countries.data?.filter(item => {
        return ['Brazil', 'Bolivia', 'Angola', 'Ghana', 'Paraguay', 'Portugal', 'South Africa'].includes(item.name)
    })
    
    useEffect(() => { onChange(city) }, [city])

    const handleChangeCountry = country => {
        setCountry(country)
        setState(null)
        setCity(null)
    }

    const handleChangeState = state => {
        setState(state)
        setCity(null)
    }

    return(
    <Stack gap={4}>

        <Form.Select
            required={required}
            disabled={disabled}
            label="Selecione o seu país:"
            value={country}
            items={countries_fileted?.map(country => ({ label: country.name, value: country.id }))}
            onChange={e => handleChangeCountry(e.target.value)}
            helper="Por enquanto a Bonífica só está disponível em alguns países."
        />

        <HStack gap={4}>
            <UI.Show visible={!!country && states.data}>
                
                <Form.Select
                    required={required}
                    disabled={disabled}
                    label="Selecione seu estado:"
                    value={state}
                    items={states.data?.map(state => ({ label: state.name, value: state.id }))}
                    onChange={e => handleChangeState(e.target.value)}
                />

            </UI.Show>

            <UI.Show visible={!!state}>
                
                <Form.Select
                    required={required}
                    disabled={disabled}
                    label="Selecione a cidade:"
                    value={city}
                    items={cities.data?.map(city => ({ label: city.name, value: city.id }))}
                    onChange={e => setCity(e.target.value)}
                />

            </UI.Show>

            <UI.Show visible={countries.isLoading || states.isLoading || cities.isLoading}><Spinner /></UI.Show>
        </HStack>
    </Stack>
    )
}